export class ProductImageModel {
    public fileId: number;
    public name: string;
    public contentType: string;
    public sizeInBytes: number;
    public content: string;
    public jsx: string;
}